import { connect } from 'react-redux';
import { toggleHerramientas } from '../actions';
import BotonHerramientas from './boton-herramientas';

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    onClick: function onClick() {
      return dispatch(toggleHerramientas());
    }
  };
};

var BotonHerramientasContainer = connect(null, mapDispatchToProps)(BotonHerramientas);
export default BotonHerramientasContainer;